module.exports = __webpack_public_path__ + "static/img/home-hero-mobile-bg-03.fe0b2cf.jpg";